import * as R from 'ramda';
import { EditorState, convertToRaw } from 'draft-js';
import { newField, fieldNames } from '../formFields/fields';

export const newFormModel = () => {
    const editorState = EditorState.createEmpty();
    const defaultField = newField(fieldNames.title);
    const newForm = {
        name: String(),
        description: String(),
        startDate: null,
        endDate: null,
        publish: 'NO',
        surveyType: 'ONETIME',
        startTime: null,
        endTime: null,
        daysOfWeek: null,
        trackUser: false,
        singleUserSubmission: false,
        confirmationMsg: convertToRaw(editorState.getCurrentContent()),
        randomOrder: false,
        disabled: false,
        userId: Number(),
        customerId: Number(),
        organizationIds: [],
        jsonSchema: {
            fields: [defaultField]
        }
    };
    return R.clone(newForm);
};
